module.exports = __webpack_public_path__ + "img/defaultImg.02beda2f.png";